import React from "react";
import styles from "./FilterRadioButton.module.scss";

type FilterRadioButtonProps = {
  title: string;
};

export const FilterRadioButton: RFC<React.InputHTMLAttributes<HTMLInputElement> & FilterRadioButtonProps> = ({
  title,
  ...props
}) => {
  return (
    <label className={styles.label}>
      <input {...props} type="radio" className={styles.inputDefaultHide} />
      <div className={styles.radio}>
        <div className={styles.circle} />
        <div className={styles.title}>{title}</div>
      </div>
    </label>
  );
};
